import React from "react";
import PropTypes from "prop-types";

interface Props {
  id: string;
  values?: { [key: string]: any };
  defaultValue?: string;
}

export default class Translate extends React.Component<Props, {}> {
  public static contextTypes = {
    translate: PropTypes.func.isRequired,
  };

  public render() {
    const { id, values, defaultValue } = this.props;
    return this.context.translate(id, values, defaultValue);
  }
}



// WEBPACK FOOTER //
// ./frontend/src/common/components/Translate.tsx